/**
 * @Author: v_jppjpeng
 * @Date: 2023-12-09 10:31:58
 * @Explain: 文本或文本标签
 */
import { intlGet } from '@/locales';
import classNames from 'classnames';
import type { CSSProperties } from 'react';
import { useMemo } from 'react';
import type { TagProps } from 'tdesign-react';
import { Tag } from 'tdesign-react';
// utils
import { formatMappingOutput } from '@/utils/common/dataConversion';
// type
import type { CommonOptionsType } from '@/definition/common/data.d';

type PropsType = {
  className?: string;
  style?: CSSProperties;
  mappingOptions?: CommonOptionsType[];
  mappingObj?: any;
  value: string | number;
  // 空位符
  vacancyCharacter?: string;
  /** 文本类型 */
  textType?: 'text' | 'tag';
  size?: TagProps['size'];
  variant?: TagProps['variant'];
  // 自定义显示文本
  customDisplayText?: string;
  /** icon组件 */
  icon?: React.ReactElement;
};

export default function TextTag(props: PropsType) {
  const {
    className,
    style,
    mappingOptions,
    mappingObj,
    value,
    vacancyCharacter = '-',
    textType = 'text',
    size = 'large',
    variant = 'light',
    customDisplayText,
    icon,
  } = props;
  const defaultObjectData: CommonOptionsType = {
    labelKey: '',
    theme: 'default',
    value: '',
  };

  const onRender = useMemo(() => {
    const { label, labelKey, theme } =
      formatMappingOutput({ mappingOptions, mappingObj, value }) ||
      defaultObjectData;
    const displayText =
      (labelKey && intlGet(labelKey)) || label || value || vacancyCharacter;
    const tagProps = {
      className: classNames(
        `default-text-tag ${textType === 'tag' ? 'td-tag' : 'td-text'}`,
        className,
      ),
      theme,
      size,
      variant,
      style,
    };
    return (
      <Tag icon={icon} {...tagProps}>
        {customDisplayText ? customDisplayText : displayText}
      </Tag>
    );
  }, [mappingObj, mappingOptions, value, className, size, variant, style]);

  return onRender;
}
